import React from "react";
import './AccountInfoScreenCard.css';

class AccountInfoScreenCard extends React.Component {

    constructor(props){
        super(props);
        
        this.state = {
        };

        this.displayCard = this.displayCard.bind(this);
           
    }

    get displayCardClass(){
        let className = 'account-info-card';
        if(this.props.emphasis){
            className += ' emphasis-card';
        }
        return className;
    }

    displayCard(){
        let elements = [];
        let labelDiv = (<></>);
        if(this.props.label){
            labelDiv = (<div className="account-info-card-label">{this.props.label}</div>);
        }
        elements.push((<div key="account-info-card-content" className="account-info-card-content">{labelDiv}{this.props.content}</div>));

        if(this.props.actions){
            elements.push((<div key="account-info-card-action" className="account-info-card-action">{this.props.actions}</div>));
        }

        return elements;
    }

    render(){

        return (
            <>
                <div className={this.displayCardClass}>
                    {this.displayCard()}
                </div>

                
            </>
        );
    }
}

export default AccountInfoScreenCard;
